module.exports = __webpack_public_path__ + "static/media/Comic Sans MS-01.4c253017.svg";